import { Grid, Box } from '@mui/material';
import { useState } from 'react';

import FormView from '../../../../components/views/formView';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';

import { InitialCausalityHistorical } from '../historical';
import { InitialCausalityData } from './data';
import { useInitialCausalityForm } from '../hook';
import {
    INITIAL_CAUSALITY_NEW,
    INITIAL_CAUSALITY_DETAIL,
    INITIAL_CAUSALITY,
} from '../../../../../routes/paths';

export const InitialCausalityForm = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const {
        initialCausality,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikInitialCausalityData,
        initialCausalityHistorical,
    } = useInitialCausalityForm(showHistorical);

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons =
        initialCausality && initialCausality?.id ? true : false;
    return (
        <>
            <FormView
                title={
                    initialCausality && initialCausality.id
                        ? 'Editar causalidad inicial'
                        : 'Crear causalidad inicial'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={initialCausality?.id || ''}
                        buttonCreate={{
                            show: showActionButtons,
                            route: INITIAL_CAUSALITY_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: INITIAL_CAUSALITY,
                        }}
                        buttonUpdate={{
                            show: false,
                        }}
                        buttonView={{
                            show: showActionButtons,
                            route: INITIAL_CAUSALITY_DETAIL,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <InitialCausalityHistorical
                        historical={initialCausalityHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <InitialCausalityData
                data={initialCausality}
                onChangeFormik={(formik) =>
                    setFormikInitialCausalityData(formik)
                }
                initialCausalityId={initialCausality?.id || ''}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
